import { z } from 'zod'

export const curriculumAim = z.union([
  z.literal('ib'),
  z.literal('regular'),
  z.literal('ims'),
  z.literal('wms'),
  z.literal('fms')
])

export const curriculumStatus = z.union([
  z.literal('active'),
  z.literal('draft')
])

export const curriculumBasketType = z.union([
  z.literal('regular'),
  z.literal('focus'),
  z.literal('select')
])
